
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import BlockIcon from '@mui/icons-material/Block';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import PauseCircleOutlineIcon from '@mui/icons-material/PauseCircleOutline';

export const warehouseRelationConfig = (isFulfilment, orderTotals) => {
    return {
        active:  {
            title: 'active',
            icon: <Inventory2OutlinedIcon/>,
            isSingleDataGrid: true,
            ...(orderTotals && {count: orderTotals.activeCount})
        },
        inactive:  {
            title: 'inactive',
            icon: <PauseCircleOutlineIcon/>,
            isSingleDataGrid: true,
            ...(orderTotals && {count: orderTotals.inActiveCount})
        },
        blocked:  {
            title: 'blocked',
            icon: <BlockIcon/>,
            isSingleDataGrid: true,
            ...(orderTotals && {count: orderTotals.blockedCount})
        },
    }
};
